// extracted by mini-css-extract-plugin
module.exports = {"tabSelectorContainer":"tabSelectorContainer-NoeVO","tabSelector":"tabSelector-R1-y-","btnTab":"btnTab-c2DLK","activeTab":"activeTab-aa0J4"};